import React, { FunctionComponent, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import { compose } from 'recompose';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { ApiResponse, CrossIxConnection } from 'constants/api';
import FormModal from './FormModal';

interface InProps {
    uuid: string;
    xmlId: string;
    onSuccess: () => void;
}

interface EnhanceProps {
    deleteCrossIxConnectionBinding: ApiDataBinding<ApiResponse<CrossIxConnection>>;
}

type Props = InProps & EnhanceProps & WithTranslation;

const enhance = compose<Props, InProps>(
    withApiData(
        {
            deleteCrossIxConnectionBinding: 'deleteCrossIxConnection',
        },
        (props: InProps) => ({
            deleteCrossIxConnectionBinding: { uuid: props.uuid },
        })
    ),
    withTranslation()
);

const CrossIxConnectionDeleteModal: FunctionComponent<Props> = ({
    xmlId,
    onSuccess,
    deleteCrossIxConnectionBinding,
    t,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }

    function onSubmit() {
        return deleteCrossIxConnectionBinding.perform();
    }

    function handleSuccess() {
        onSuccess();
    }

    return (
        <React.Fragment>
            <FormModal
                header={t('crossIxConnectionDeleteModal.title')}
                isOpen={isOpen}
                toggle={toggle}
                initialValues={{}}
                onSubmit={onSubmit}
                onSuccess={handleSuccess}
                successMessage={t('notification.archiveContractSuccessful')}
            >
                {() => (
                    <React.Fragment>
                        <Alert color="warning" className="mb-0">
                            <strong>{t('common.warning')}</strong>
                            <p>{t('crossIxConnectionDeleteModal.warningMessage', { xmlId })}</p>
                        </Alert>
                    </React.Fragment>
                )}
            </FormModal>

            <span
                data-test="cross-ix-connection-delete-btn"
                className="fas fa-trash fa-pull-left mt-1 text-primary cursor-pointer"
                onClick={toggle}
                title={t('crossIxConnectionDeleteModal.btnTooltip')}
            />
        </React.Fragment>
    );
};

export default enhance(CrossIxConnectionDeleteModal);
